import React from "react";

var OpenInNewTab3Component = function OpenInNewTab3Component(_ref) {
  var size = _ref.size;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0H15.5H16V0.5V5.5V6H15V5.5V1.71875L7.34375 9.375L7 9.71875L6.28125 9L6.625 8.65625L14.2812 1H10.5H10V0H10.5ZM0.5 1H6.5H7V2H6.5H1V15H14V9.5V9H15V9.5V15.5V16H14.5H0.5H0V15.5V1.5V1H0.5Z",
    fill: "currentColor"
  }));
}; // Create the component with index signature to satisfy the type system


var OpenInNewTab3 = Object.assign(OpenInNewTab3Component, {
  displayName: "OpenInNewTab3"
});
export default OpenInNewTab3;